
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/web/user-setting",
      function () {
        return require("private-next-pages/web/user-setting.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/web/user-setting"])
      });
    }
  